import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface SideNavItemProps {
  title: string;
  url: string;
  isSubItem?: boolean;
  icon?: React.ReactElement;
  setPageTitle?: Dispatch<SetStateAction<string>>;
  subtitle?: string;
}

export const SideNavItem = ({
  title,
  url,
  isSubItem = false,
  icon,
  setPageTitle,
  subtitle,
}: SideNavItemProps) => {
  const location = useLocation();
  // Remove trailing slash from pathname
  const currentLocation = location.pathname.replace(/\/$/, "");
  const isCurrentTab: boolean = url === currentLocation.slice(-url.length);
  const navigate = useNavigate();

  if (isCurrentTab && setPageTitle && url.includes("segments")) {
    setPageTitle("Segments");
  } else if (isCurrentTab && setPageTitle) {
    setPageTitle(title);
  }

  return (
    <Box
      color={isCurrentTab ? "white" : "muted"}
      borderRadius={"md"}
      py={1}
      px={1}
      mb={1}
      ml={isSubItem ? 4 : "auto"}
      cursor={"pointer"}
      _hover={{
        bg: "tertiary.light",
        color: "white",
      }}
      bg={isCurrentTab ? "tertiary.light" : "transparent"}
      onClick={() => {
        url && navigate(url);
      }}
      width={"100%"}
    >
      <HStack>
        {icon && icon}
        <VStack spacing={0}>
          <Text fontSize={"14px"}>{title}</Text>
          {/* <Spacer /> */}
          {subtitle && <Text fontSize="10px">{subtitle}</Text>}
        </VStack>
      </HStack>
    </Box>
  );
};
